import { MILLISECONDS_PER_SECOND } from 'constants/date';

export const CONTENT_ANIMATION_DURATION = 0.25 * MILLISECONDS_PER_SECOND;
export const DEFAULT_TYPING_ANIMATION_DURATION = 1.5 * MILLISECONDS_PER_SECOND;
export const FORCED_SYSTEM_TYPING_DURATION = 20 * MILLISECONDS_PER_SECOND;
